import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MaskLines, Overline } from "./Reveal";
import { PRICES, CONTACT } from "./data";

export const Prices = () => (
  <section id="listino" data-testid="prices-section" className="relative py-24 sm:py-36">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4 lg:sticky lg:top-28 self-start">
        <Overline>Listino</Overline>
        <h2 className="mt-6 font-display text-5xl sm:text-6xl leading-[0.95] text-ivory">
          <MaskLines lines={["Prezzi", <em key="p" className="text-gold-grad">trasparenti.</em>]} />
        </h2>
        <p className="mt-6 max-w-xs text-sm text-ivory/70 leading-relaxed">Prezzi di partenza indicativi. Il preventivo esatto dipende da lunghezza e tecnica: te lo confermiamo prima di iniziare.</p>
        <a data-testid="prices-treatwell-link" href={CONTACT.treatwell} target="_blank" rel="noreferrer" className="btn-ghost mt-8">
          Listino completo su Treatwell <ArrowUpRight className="w-4 h-4" />
        </a>
      </div>
      <ul className="lg:col-span-8 border-t border-white/10">
        {PRICES.map(([name, sub, price], i) => (
          <motion.li
            key={name}
            data-testid={`price-row-${i}`}
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay: i * 0.05 }}
            className="price-row group relative flex items-baseline gap-4 py-6 border-b border-white/10"
          >
            <span className="font-mono text-[11px] text-gold/80 w-8">{String(i + 1).padStart(2, "0")}</span>
            <span className="flex-1">
              <span className="block font-display text-2xl sm:text-3xl text-ivory transition-transform duration-500 group-hover:translate-x-3">{name}</span>
              <span className="block mt-1 text-xs sm:text-sm text-ivory/60">{sub}</span>
            </span>
            <span className="font-mono text-sm sm:text-base text-gold whitespace-nowrap">{price}</span>
          </motion.li>
        ))}
      </ul>
    </div>
  </section>
);
